<template>
    <el-drawer
        :title="detailData.title"
        :visible.sync="detailParam.visible"
        size="520px"
        :close-on-press-escape="false"
        :wrapperClosable="false"
    >
        <div class="drawer-wrapper">
            <div class="drawer-main" v-loading="detailData.loading.main">
                <div class="drawer-body">
                    <el-form :model="detailData" ref="detailData" label-position="top" size="small">
                        <el-form-item
                            label="公海名称："
                            prop="row.name"
                            :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                        >
                            <el-input v-model="detailData.row.name"></el-input>
                        </el-form-item>
                        <el-form-item label="跟进回收规则：">
                            <el-radio-group v-model="detailData.row.follow" size="small">
                                <el-radio-button :label="1">开启</el-radio-button>
                                <el-radio-button :label="0">关闭</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item>
                            <el-input
                                v-model.number="detailData.row.follow_days"
                                controls-position="right"
                                :disabled="!detailData.row.follow"
                            >
                                <template slot="append">天没有跟进记录，自动回收</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="成交回收规则：">
                            <el-radio-group v-model="detailData.row.order" size="small">
                                <el-radio-button :label="1">开启</el-radio-button>
                                <el-radio-button :label="0">关闭</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item>
                            <el-input
                                v-model.number="detailData.row.order_days"
                                controls-position="right"
                                :disabled="!detailData.row.order"
                            >
                                <template slot="append">天没有跟进记录，自动回收</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-radio-group v-model="detailData.row.default">
                                <el-radio-button :label="1">设为默认公海</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="备注：" prop="row.memo">
                            <el-input type="textarea" v-model="detailData.row.memo"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                :loading="detailData.loading.submit"
                                @click="SubmitDetail('detailData')"
                                >保 存</el-button
                            >
                            <el-button size="small" @click="detailParam.visible = false"
                                >取 消</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import { UserData } from '@/plugin/User'
export default {
    name: 'v-sea',
    inject: ['reload'],
    mixins: [UserData],
    props: ['detailParam'],
    data() {
        return {
            userData: {
                loading: {
                    list: true
                },
                list: []
            },
            detailData: {
                loading: {
                    main: false,
                    submit: false
                },
                title: '公海设置',
                row: {
                    id: null,
                    name: null,
                    members_array: [],
                    members: null,
                    follow: 0,
                    follow_days: null,
                    order: 0,
                    order_days: 0,
                    default: 0,
                    memo: null
                }
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.GetUser()
        })
    },
    mounted() {
        this.$nextTick(() => {
            if (this.detailParam.row.id) {
                this.GetDetail()
            }
        })
    },
    methods: {
        GetUser() {
            if (!this.userData.list.length) {
                this.GetUserData().then(res => {
                    this.userData.loading.list = false
                    this.userData.list = res.list
                })
            }
        },
        GetDetail() {
            this.detailData.loading.main = true
            this.$request({
                url: '/api/v1/customer_sea/' + this.detailParam.row.id,
                params: {
                    ...this.detailParam.row
                }
            }).then(res => {
                if (!res.status) {
                    this.detailData.loading.main = false
                    this.detailData.row = {
                        id: res.data.id,
                        name: res.data.name,
                        members_array: [],
                        members: null,
                        follow: res.data.follow_days ? 1 : 0,
                        follow_days: res.data.follow_days,
                        order: res.data.order_days ? 1 : 0,
                        order_days: res.data.order_days,
                        memo: res.data.memo
                    }
                    res.data.members.forEach(row => {
                        this.detailData.row.members_array.push(row.user_id)
                    })
                }
            })
        },
        SubmitDetail(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.detailData.row.members = JSON.stringify(this.detailData.row.members_array)
                    if (!this.detailData.row.follow) {
                        this.detailData.row.follow_days = 0
                    }
                    if (!this.detailData.row.order) {
                        this.detailData.row.order_days = 0
                    }
                    this.detailData.loading.submit = true
                    this.$request({
                        url: '/api/v1/customer_sea_add',
                        params: {
                            ...this.detailData.row
                        }
                    }).then(res => {
                        this.detailData.loading.submit = false
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.reload()
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
</style>
